import { useEffect, useState } from 'react';

/** True at the lg breakpoint and up — used to keep scroll-linked motion off small screens. */
export function useIsDesktop(query = '(min-width: 1024px)'): boolean {
  const [matches, setMatches] = useState(() => (typeof window === 'undefined' ? true : window.matchMedia(query).matches));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
